<template>
    <div class="flex h-screen overflow-hidden">
        <side-bar :sidebar-open="sidebarOpen" @close-sidebar="sidebarOpen = false" />

        <div class="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
            <header-bar :sidebar-open="sidebarOpen" @toggle-sidebar="sidebarOpen = !sidebarOpen" />

            <main>
                <div class="p-2 sm:px-3 lg:px-4 w-full max-w-xxl mx-auto">
                    <slot />
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import { defineComponent, ref } from 'vue'
    import SideBar from '@/Components/SideBar.vue'
    import HeaderBar from '@/Components/HeaderBar.vue'

    export default defineComponent({
        components: {
            SideBar,
            HeaderBar
        },

        setup() {
            const sidebarOpen = ref(false)

            return {
                sidebarOpen
            }
        }
    })
</script>
